<template>
  <div>
    <h1>Loading Page</h1>

    <LoadingPage>
      <template slot="title">
        Something is happening please wait...
      </template>
    </LoadingPage>

    <LoadingPage>
      <template slot="title">
        Your documents are loading...
      </template>
    </LoadingPage>
  </div>
</template>

<script>
import { LoadingPage } from '@/components/library/loaders/loadingPage/LoadingPage';

export default {
  components: { LoadingPage },
};
</script>

<style>
</style>
